export type PhotoEntityType = "gphoto" | "picsum"

export type PhotoEntityProps = {
  id: string
  type: PhotoEntityType
  originalUrl: string
  originalWidth: number
  originalHeight: number
}
export class PhotoEntity {
  public readonly id: string
  public readonly type: PhotoEntityType
  public readonly originalUrl: string
  public readonly originalWidth: number
  public readonly originalHeight: number

  constructor({
    id,
    type,
    originalUrl,
    originalWidth,
    originalHeight
  }: PhotoEntityProps) {
    this.id = id
    this.type = type
    this.originalUrl = originalUrl
    this.originalWidth = originalWidth
    this.originalHeight = originalHeight
  }
}

export const AspectFloat = {
  "3x2": 3 / 2,
  "1x1": 1,
  "2x3": 2 / 3,
  "3x4": 3 / 4,
  "4x3": 4 / 3,
  "16x10": 16 / 10,
  "16x9": 16 / 9,
  "10x16": 10 / 16,
  "9x16": 9 / 16,
  unknown: NaN
}
export type PhotoAspect = keyof typeof AspectFloat

const gPhotoUrlRegexp = /\/s\d+\//

export class PhotoView {
  public readonly entity: PhotoEntity
  constructor(entity: PhotoEntity) {
    this.entity = entity
  }

  private nearAspect(aspect: PhotoAspect): boolean {
    if (aspect === "unknown") return false

    const v = Math.abs(
      1 -
        (this.entity.originalHeight / this.entity.originalWidth) *
          AspectFloat[aspect]
    )
    if (v < 0.02) {
      return true
    } else {
      return false
    }
  }

  public get id(): string {
    return this.entity.id
  }

  public get aspect(): PhotoAspect {
    const aspects = Object.keys(AspectFloat) as [PhotoAspect]
    const aspect = aspects.find(v => this.nearAspect(v)) || "unknown"
    return aspect
  }

  // 4:3 なら 1.33333333
  public get aspectWidth(): number {
    if (this.aspect === "unknown") {
      return this.entity.originalHeight / this.entity.originalWidth
    }
    return 1.0 / AspectFloat[this.aspect]
  }

  // 4:3 なら 0.75
  public get aspectHeight(): number {
    if (this.aspect === "unknown") {
      return this.entity.originalWidth / this.entity.originalHeight
    }
    return AspectFloat[this.aspect]
  }

  public get url(): string {
    return this.detectURL()
  }

  public thumbnail(size: number = 600): string {
    return this.detectURL(size)
  }

  public detectURL(size?: number): string {
    const url = this.entity.originalUrl
    switch (this.entity.type) {
      case "gphoto":
        const [prefix, suffix] = url.split(gPhotoUrlRegexp)
        return `${prefix}/s${size || 0}/${suffix}`
      case "picsum":
        // `https://picsum.photos/id/${id}/${h}/${w}`
        const picsumId = url.split("/")[4]
        if (size) {
          const w = size
          const h = size * this.aspectWidth
          return `https://picsum.photos/id/${picsumId}/${w.toFixed()}/${h.toFixed()}.jpg`
        } else {
          return url
        }
      default:
        return url
    }
  }
}
